var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderCheck2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.16668L9.16667 12.5L7.5 10.8333M2.5 5.00001V14C2.5 14.9334 2.5 15.3998 2.68166 15.7563C2.84144 16.0699 3.09623 16.3254 3.40983 16.4852C3.766 16.6667 4.23249 16.6667 5.16409 16.6667H14.8359C15.7675 16.6667 16.2333 16.6667 16.5895 16.4852C16.9031 16.3254 17.1587 16.0701 17.3185 15.7565C17.5002 15.4 17.5002 14.9333 17.5002 13.9998L17.5002 7.66649C17.5002 6.73307 17.5002 6.26636 17.3185 5.90984C17.1587 5.59624 16.9033 5.34145 16.5897 5.18167C16.2331 5.00001 15.7668 5.00001 14.8333 5.00001H10M2.5 5.00001H10M2.5 5.00001C2.5 4.07954 3.24619 3.33334 4.16667 3.33334H7.22876C7.63642 3.33334 7.84072 3.33334 8.03253 3.37939C8.20259 3.42022 8.36488 3.48773 8.514 3.57911C8.68214 3.68215 8.82651 3.82652 9.11458 4.11459L10 5.00001",
    stroke: "#00AA5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCheck2);
export default __webpack_public_path__ + "static/media/folderCheck2.4ca787aecb0a43c93c5f9fdbcb3f67ad.svg";
export { ForwardRef as ReactComponent };